import useQueryUrlParam from 'core/hooks/useQueryUrlParam';
import DgPagination from 'styles/UI/Pagination/DgPagination';
import DgTable from 'styles/UI/Table/DgTable';
import { useUserTransferQuery } from '../hooks/react-query/useUserTransferQuery';
import UserTransferTableColumn from './UserTransferTableColumn';

const UserTransferTable = () => {
	const { data: transfers, isFetching: transferIsFetching } = useUserTransferQuery();
	const { query, handlePagination } = useQueryUrlParam();

	return (
		<>
			<DgTable
				rowKey='id'
				columns={UserTransferTableColumn()}
				dataSource={transfers?.data?.list}
				count={transfers?.data.pagination.total}
				loading={transferIsFetching}
				current={transfers?.data.pagination.current_page}
				per_page={query?.per_page}
			/>
			<DgPagination
				onPaginationHandler={handlePagination}
				responsive={true}
				per_page={query?.per_page}
				current={transfers?.data.pagination.current_page}
				total={transfers?.data.pagination.total}
			/>
		</>
	);
};

export default UserTransferTable;
